const morganStateCampusLocations = [
    {
        "name": "Earl S. Richardson Library",
        "description": "Main campus library with study spaces and resources."
    },
    {
        "name": "University Student Center",
        "description": "Central hub for student activities and dining."
    },
    {
        "name": "McMechen Hall",
        "description": "Academic building with classrooms and offices."
    },
    {
        "name": "Clarence M. Mitchell Jr. Engineering Building",
        "description": "Houses engineering labs and classrooms."
    },
    {
        "name": "Jenkins Behavioral Science Building",
        "description": "Home to psychology and behavioral science departments."
    },
    {
        "name": "Truth Hall",
        "description": "Student residence hall with study areas."
    },
    {
        "name": "Carl J. Murphy Fine Arts Center",
        "description": "Performing arts venue and classrooms."
    },
    {
        "name": "Hill Field House",
        "description": "Athletic facility with multiple study spaces."
    },
    {
        "name": "Schaefer Engineering Building",
        "description": "Modern engineering facilities and study rooms."
    }
];

export default morganStateCampusLocations;